<div class="flexRow errorTip">
  <i nz-icon nzIconfont="icon_notice" class="text-xs waringIcon"></i>
  <div class="errorTipText ml-xs">{{ data }}</div>
</div>
